<div class="flex gap-4">
  <div class="w-1/4">
    <div class="flex flex-col gap-2">
      @for (step of steps; track index; let index = $index) {
        <a href="#"
           class="px-3 py-2 rounded flex justify-between text-sm hover:cursor-pointer hover:bg-slate-100 hover:text-primary ease-in-out duration-200"
           [ngClass]="currentStep === index ? 'bg-slate-200 text-primary font-bold' : 'text-secondary bg-slate-50'"
           (click)="$event.preventDefault(); currentStep = index"
        >
          <div>{{ step.title | translate }}</div>
          @if (step.fn && typeof step.fn === 'function' && step.fn()) {
            <div class="text-theme-green">
              <lucide-icon size="18" [name]="CircleCheck"></lucide-icon>
            </div>
          }
        </a>
      }
    </div>
  </div>
  <div class="w-3/4">
    <div [ngClass]="{ 'hidden': currentStep !== 0 }">
      <app-card>
        <form [formGroup]="searchForm">
          <div class="flex gap-2">
            <div class="w-1/4">
              <app-input-group>
                <label appLabel>{{ 'meter.commissioningDate' | translate }}</label>
                <input appInputDate formControlName="commissioningDate">
              </app-input-group>
            </div>
            <div class="w-1/4">
              <app-input-group>
                <label appLabel>{{ 'meter.meterNumber' | translate }}</label>
                <input type="text" appInput formControlName="meterNumber" [placeholder]="'meter.meterNumber' | translate">
              </app-input-group>
            </div>

            <div class="w-1/4">
              <app-input-group>
                <label appLabel>{{ 'meter.alternativeMeterNumber' | translate }}</label>
                <input type="text" appInput formControlName="alternativeMeterNumber" [placeholder]="'meter.alternativeMeterNumber' | translate">
              </app-input-group>
            </div>

            <div class="w-1/4">
              <app-input-group>
                <label appLabel>{{ 'meter.serialNumber' | translate }}</label>
                <input type="text" appInput formControlName="serialNumber" [placeholder]="'meter.serialNumber' | translate">
              </app-input-group>
            </div>
          </div>
          <div>
            <button appButton (click)="table.search()">{{ 'common.search' | translate }}</button>
          </div>
        </form>
      </app-card>

      <div class="mt-4">
        <app-table
          #table
          [config]="meterSimpleTableConfig"
          [(selectedElements)]="selectedElements"
          (selectedElementsChange)="changeSelectedMeter($event)"
        ></app-table>

        @if (selectedElements.length === 1) {
          <div class="mt-4 flex justify-end">
            <button appButton (click)="currentStep = currentStep + 1">{{ 'common.next' | translate }}</button>
          </div>
        }
      </div>
    </div>
    @if (currentStep === 1) {
      <div>
        <div class="mb-4">
          <div class="flex flex-col gap-2 text-sm text-secondary">
            <label class="flex items-center gap-2">
              <input
                appInput
                type="radio"
                name="meterChangeMode"
                [checked]="meterReadingSkipped"
                (change)="setMeterReadingSkipped(true)">
              <span [ngClass]="meterReadingSkipped ? 'font-semibold text-primary' : ''">
                {{ 'meterFrame.changeMeter.simple' | translate }}
              </span>
            </label>
            <label class="flex items-center gap-2">
              <input
                appInput
                type="radio"
                name="meterChangeMode"
                [checked]="!meterReadingSkipped"
                (change)="setMeterReadingSkipped(false)">
              <span [ngClass]="!meterReadingSkipped ? 'font-semibold text-primary' : ''">
                {{ 'meterFrame.changeMeter.precise' | translate }}
              </span>
            </label>
          </div>
        </div>

        @if (!meterReadingSkipped) {
        <form [formGroup]="form">
          <table class="bg-gray-100 border-collapse table-fixed w-full overflow-hidden rounded-t-md text-sm">
            <thead>
            <tr>
              <th class="bg-gray-100 w-1/12 px-2 py-3 rounded-t-sm text-left font-semibold text-secondary border-slate-200 border not:first-of-type:border-l-transparent"></th>
              <th class="bg-gray-100 px-2 py-3 rounded-t-sm text-left font-semibold text-secondary border-slate-200 border not:first-of-type:border-l-transparent">
                {{ 'meterFrame.changeMeter.currentMeter' | translate }}
              </th>
              <th class="bg-gray-100 px-2 py-3 rounded-t-sm text-left font-semibold text-secondary border-slate-200 border not:first-of-type:border-l-transparent">
                {{ 'meterFrame.changeMeter.newMeter' | translate }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-center font-semibold align-middle border-slate-200 border py-2 text-secondary">
                {{ 'meterFrame.changeMeter.changeDate' | translate }}
              </td>
              <td class="text-center font-normal align-middle px-2 border-slate-200 border py-2 text-secondary" formGroupName="currentMeter">
                <input appInputDate type="datetime-local" formControlName="changeDate">
              </td>
              <td class="text-center font-normal align-middle px-2 border-slate-200 border py-2 text-secondary" formGroupName="newMeter">
                <input appInputDate type="datetime-local" formControlName="changeDate">
              </td>
            </tr>
            <tr class="bg-slate-50">
              <td class="text-center font-semibold align-middle border-slate-200 border py-2 text-secondary">
                A14
              </td>
              <td class="text-center font-normal align-middle px-2 border-slate-200 border py-2 text-secondary" formGroupName="currentMeter">
                <app-input-group>
                  <input appInputNumber formControlName="A14_measured" append="kWh">
                </app-input-group>
              </td>
              <td class="text-center font-normal align-middle px-2 border-slate-200 border py-2 text-secondary" formGroupName="newMeter">
                <app-input-group>
                  <input appInputNumber formControlName="A14_measured" append="kWh">
                </app-input-group>
              </td>
            </tr>
            <tr>
              <td class="text-center font-semibold align-middle border-slate-200 border py-2 text-secondary">
                A23
              </td>
              <td class="text-center font-normal align-middle px-2 border-slate-200 border py-2 text-secondary" formGroupName="currentMeter">
                <app-input-group>
                  <input appInputNumber formControlName="A23_measured" append="kWh">
                </app-input-group>
              </td>
              <td class="text-center font-normal align-middle px-2 border-slate-200 border py-2 text-secondary" formGroupName="newMeter">
                <app-input-group>
                  <input appInputNumber formControlName="A23_measured" append="kWh">
                </app-input-group>
              </td>
            </tr>
            <tr class="bg-slate-50">
              <td class="text-center font-semibold align-middle border-slate-200 border py-2 text-secondary">
                R12
              </td>
              <td class="text-center font-normal align-middle px-2 border-slate-200 border py-2 text-secondary" formGroupName="currentMeter">
                <app-input-group>
                  <input appInputNumber formControlName="R12_measured" append="kWh">
                </app-input-group>
              </td>
              <td class="text-center font-normal align-middle px-2 border-slate-200 border py-2 text-secondary" formGroupName="newMeter">
                <app-input-group>
                  <input appInputNumber formControlName="R12_measured" append="kWh">
                </app-input-group>
              </td>
            </tr>
            <tr class="border">
              <td class="text-center font-semibold align-middle border-slate-200 border py-2 text-secondary">
                R34
              </td>
              <td class="text-center font-normal align-middle px-2 border-slate-200 border py-2 text-secondary" formGroupName="currentMeter">
                <app-input-group>
                  <input appInputNumber formControlName="R34_measured" append="kWh">
                </app-input-group>
              </td>
              <td class="text-center font-normal align-middle px-2 border-slate-200 border py-2 text-secondary" formGroupName="newMeter">
                <app-input-group>
                  <input appInputNumber formControlName="R34_measured" append="kWh">
                </app-input-group>
              </td>
            </tr>
            </tbody>
          </table>
        </form>
        }

        <div class="mt-4 flex justify-between">
          <button appButton type="secondary" (click)="currentStep = currentStep - 1">{{ 'common.back' | translate }}</button>
          <button [disabled]="form.invalid" appButton (click)="currentStep = currentStep + 1">{{ 'common.next' | translate }}</button>
        </div>
      </div>
    } @if (currentStep === 2) {
    @if (meterReadingSkipped) {
      <div class="rounded-md py-3 text-sm text-secondary">
        <span class="font-semibold">{{ 'meterFrame.changeMeter.changeDate' | translate }}: </span>
        <span class="font-normal">{{ (searchForm.get('commissioningDate')?.value | date: DATE_FORMAT) ?? '-' }}</span>
      </div>
    }

    <table class="w-full text-sm mb-4">
      <thead>
      <tr>
        <th class="w-1/5 text-center font-semibold align-middle border-b-slate-200 border-b py-2"></th>
        <th class="w-1/5 text-center font-semibold align-middle border-b-slate-200 border-b py-2">
          {{ 'meterFrame.changeMeter.currentMeter' | translate }}
        </th>
        <th class="w-1/5 text-center font-semibold align-middle border-b-slate-200 border-b py-2">
          {{ 'meterFrame.changeMeter.newMeter' | translate }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr class="bg-slate-50">
        <td class="w-1/5 px-2 font-semibold align-middle border-b-slate-200 border-b py-2 text-secondary">
          {{ 'meteringPoint.create.meterNumber' | translate }}
        </td>
        <td class="w-1/5 text-center font-normal align-middle border-b-slate-200 border-b py-2 text-secondary">
          {{ form.get('currentMeter.meterNumber')?.value ?? '-' }}
        </td>
        <td class="w-1/5 text-center font-normal align-middle border-b-slate-200 border-b py-2 text-secondary">
          {{ form.get('newMeter.meterNumber')?.value ?? '-' }}
        </td>
      </tr>

      @if (!meterReadingSkipped) {
        <tr>
          <td class="w-1/5 px-2 font-semibold align-middle border-b-slate-200 border-b py-2 text-secondary">
            {{ 'meterFrame.changeMeter.changeDate' | translate }}
          </td>
          <td class="w-1/5 text-center font-normal align-middle border-b-slate-200 border-b py-2 text-secondary">
            {{ (form.get('currentMeter.changeDate')?.value | date: DATE_TIME_FORMAT) ?? '-' }}
          </td>
          <td class="w-1/5 text-center font-normal align-middle border-b-slate-200 border-b py-2 text-secondary">
            {{ (form.get('newMeter.changeDate')?.value | date: DATE_TIME_FORMAT) ?? '-' }}
          </td>
        </tr>
        <tr class="bg-slate-50">
          <td class="w-1/5 px-2 font-semibold align-middle border-b-slate-200 border-b py-2 text-secondary">
            A14
          </td>
          <td class="w-1/5 text-center font-normal align-middle border-b-slate-200 border-b py-2 text-secondary">
            {{ form.get('currentMeter.A14_measured')?.value ?? '-' }}
          </td>
          <td class="w-1/5 text-center font-normal align-middle border-b-slate-200 border-b py-2 text-secondary">
            {{ form.get('newMeter.A14_measured')?.value ?? '-' }}
          </td>
        </tr>

        <tr>
          <td class="w-1/5 px-2 font-semibold align-middle border-b-slate-200 border-b py-2 text-secondary">
            A23
          </td>
          <td class="w-1/5 text-center font-normal align-middle border-b-slate-200 border-b py-2 text-secondary">
            {{ form.get('currentMeter.A23_measured')?.value ?? '-' }}
          </td>
          <td class="w-1/5 text-center font-normal align-middle border-b-slate-200 border-b py-2 text-secondary">
            {{ form.get('newMeter.A23_measured')?.value ?? '-' }}
          </td>
        </tr>

        <tr class="bg-slate-50">
          <td class="w-1/5 px-2 font-semibold align-middle border-b-slate-200 border-b py-2 text-secondary">
            R12
          </td>
          <td class="w-1/5 text-center font-normal align-middle border-b-slate-200 border-b py-2 text-secondary">
            {{ form.get('currentMeter.R12_measured')?.value ?? '-' }}
          </td>
          <td class="w-1/5 text-center font-normal align-middle border-b-slate-200 border-b py-2 text-secondary">
            {{ form.get('newMeter.R12_measured')?.value ?? '-' }}
          </td>
        </tr>

        <tr>
          <td class="w-1/5 px-2 font-semibold align-middle border-b-slate-200 border-b py-2 text-secondary">
            R34
          </td>
          <td class="w-1/5 text-center font-normal align-middle border-b-slate-200 border-b py-2 text-secondary">
            {{ form.get('currentMeter.R34_measured')?.value ?? '-' }}
          </td>
          <td class="w-1/5 text-center font-normal align-middle border-b-slate-200 border-b py-2 text-secondary">
            {{ form.get('newMeter.R34_measured')?.value ?? '-' }}
          </td>
        </tr>
      }
      </tbody>
    </table>

    <div class="mt-4 flex justify-between">
      <button appButton type="secondary" (click)="currentStep = currentStep - 1">{{ 'common.back' | translate }}</button>
      <button [disabled]="form.invalid" appButton (click)="submit()">{{ 'common.replace' | translate }}</button>
    </div>
  }
  </div>
</div>
